import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { Icon, Popup } from '@elements';
import { StyledContent, StyledHeader, StyledPopup } from './default.styles';
import logo from '@images/logo-big.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var DefaultPopup = function DefaultPopup(_ref) {
  var rejectPopup = _ref.rejectPopup,
      popUp = _ref.popUp;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var header = popUp && popUp.data && popUp.data.header;
  var body = popUp && popUp.data && popUp.data.body || t('components.popups.error.description');
  return /*#__PURE__*/_jsxs(StyledPopup, {
    width: 480,
    fullWidth: true,
    popUp: popUp,
    children: [/*#__PURE__*/_jsx(Popup.Title, {
      children: /*#__PURE__*/_jsx(StyledHeader, {
        children: /*#__PURE__*/_jsx(Icon, {
          src: logo,
          width: 88,
          height: 88
        })
      })
    }), /*#__PURE__*/_jsx(Popup.Content, {
      children: /*#__PURE__*/_jsxs(StyledContent, {
        flexDirection: "column",
        pt: 3,
        children: [header && /*#__PURE__*/_jsx(Typography, {
          color: "textPrimary",
          variant: "h4",
          textAlign: "center",
          children: header
        }), body && /*#__PURE__*/_jsx(Typography, {
          color: "#FFF",
          variant: "h4",
          textAlign: "center",
          pt: header ? 2 : undefined,
          children: body
        })]
      })
    })]
  });
};

export { DefaultPopup };